<div
    *ngIf="activeTemplateConfig.unique"
    class="logs-signpost-default-header__wrapper"
>
    <div
        *ngIf="logsSignpostStore.logsDefaultSignpostData$ | async as logsSignpostData"
        class="logs-signpost-default-header__content"
    >
        <span class="logs-signpost-default-header__content-number">
            {{  logsSignpostData.length }}
        </span>
        <span class="logs-signpost-default-header__content-contentText">
            {{ activeTemplateConfig.unique + (logsSignpostData.length !== 1 && (activeTemplateConfig.uniquePluralEnd || 's') || '') }}
        </span>
        <div class="logs-signpost-default-header__content-line"></div>
    </div>
</div>
